export default __webpack_public_path__ + "static/media/loading2.803f2436.gif";